import {
  BACKEND_CSS,
  FRONTEND_CSS,
  INFRASTRUCTURE_CSS,
  MOBILE_CSS,
  OTHERS_CSS,
} from "../constant";

export const projects = [
  {
    title: "BETTER Mobile Threat Defense",
    desc: "Cybersecurity company focused on helping companies and their employees protect their data from the broadest range of threats.",
    image: "/images/better.png",
    languages: [
      {
        name: "Angular JS",
        classes: FRONTEND_CSS,
      },
      {
        name: "React JS",
        classes: FRONTEND_CSS,
      },
      {
        name: ".NET",
        classes: BACKEND_CSS,
      },
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Jenkins",
        classes: OTHERS_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
    ],
    from: "Sep 31, 2012",
    to: "Dec 1, 2018",
    link: "https://www.better.mobi/",
  },
  {
    title: "Apothany",
    desc: "Apothany is a lifestyle and beauty social media platform designed to revolutionise the digital experience.",
    image: "/images/apothany.svg",
    languages: [
      {
        name: "React Native",
        classes: FRONTEND_CSS,
      },
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
    ],
    from: "May 4, 2022",
    to: "On going",
    link: "https://www.apothany.com",
  },
   
  {
    title: "Now Patient",
    desc: "UK NHS-approved app that delivers your repeat prescriptions straight to your door, FREE of charge.",
    image: "/images/now.svg",
    languages: [
      {
        name: "Next JS",
        classes: FRONTEND_CSS,
      },
      
      {
        name: "TailwindCSS",
        classes: FRONTEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
    ],
    from: "Sep 15, 2021",
    to: "Mar 31, 2022",
    link: "https://nowpatient.com",
  },
  {
    title: "SIID",
    desc: "The all-in-one order management and shipping platform that makes post-purchase simpler and smarter for online sellers.",
    image: "/images/siid_logo_dark.svg",
    languages: [
      {
        name: "Angular",
        classes: FRONTEND_CSS,
      },
      {
        name: "TailwindCSS",
        classes: FRONTEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
    ],
    from: "June 17, 2021",
    to: "Sep 15, 2021",
    link: "https://www.siid.com",
  },
  {
    title: "Mayaflicks Web App",
    desc: "Mayaflicks is a streaming service that offers a variety of TV programmes, films, documentaries on internet-connected devices.",
    image: "/images/maya.png",
    languages: [
      {
        name: "React JS",
        classes: FRONTEND_CSS,
      },
      {
        name: "TailwindCSS",
        classes: FRONTEND_CSS,
      },
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
    ],
    from: "Jan 15, 2021",
    to: "Dec 31, 2022",
    link: "https://mayaflicks.com",
  },
  {
    title: "Mayaflicks iOS App",
    desc: "Mayaflicks is a streaming service that offers a wide variety of TV programmes, films, anime, documentaries on internet-connected devices.",
    image:
      "https://cdn.iconscout.com/icon/free/png-512/m-characters-character-alphabet-letter-36047.png",
    languages: [
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
      {
        name: "React Native",
        classes: MOBILE_CSS,
      },
    ],
    from: "Jan 15, 2021",
    to: "Dec 31, 2022",
    link: "https://apps.apple.com/us/app/mayaflicks/id6444274036",
  },
  {
    title: "Mayaflicks Android App",
    desc: "Mayaflicks is a streaming service that offers a wide variety of TV programmes, films, anime, documentaries on internet-connected devices.",
    image:
      "https://cdn.iconscout.com/icon/free/png-512/m-characters-character-alphabet-letter-36047.png",
    languages: [
  
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
      {
        name: "React Native",
        classes: MOBILE_CSS,
      },
    ],
    from: "Jan 15, 2021",
    to: "Dec 31, 2022",
    link: "https://play.google.com/store/apps/details?id=com.mayaflix.app",
  },
  {
    title: "Shekla",
    desc: "Shekla is part of a digital music service that consists of a Music Point of Sale and a Music Store Mobile App.",
    image:
      "https://play-lh.googleusercontent.com/HQumLvP9foDMX9b2IA9rXB5CLeTq-7KlURVM-9AwF5y6YWkE9R8UF2JZGcbYLpsMR4eF=w480-h960-rw",
    languages: [
  
      {
        name: "React Native",
        classes: MOBILE_CSS,
      },
      
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
    ],
    from: "July 15, 2022",
    to: "On going",
    link: "https://play.google.com/store/apps/details?id=com.shekla",
  },
  {
    title: "Vacation",
    desc: "Vacation is a premier travel planning service that combines the valuable services of travel specialists.",
    image:
      "https://www.vacation.com/images/logo.webp",
    languages: [
  
      {
        name: "React Native",
        classes: MOBILE_CSS,
      },
      
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
    ],
    from: "July 15, 2021",
    to: "Dec 1, 2022",
    link: "https://www.vacation.com",
  },
  {
    title: "Obodo",
    desc: "Company website",
    image: "/images/obodo.svg",
    languages: [
      {
        name: "Next JS",
        classes: FRONTEND_CSS,
      },
      
      {
        name: "TailwindCSS",
        classes: FRONTEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
    ],
    from: "July 15, 2021",
    to: "July 31, 2021",
    link: "https://www.obodo.co.uk/",
  },
  {
    title: "Bookisa",
    desc: "Bookisa offers, thousands of hosts and travelers choose to create a free Bookisa account so they can list their space and book unique accommodations anywhere in the Ethiopia.",
    image: "images/bookisa.jfif",
    languages: [
      {
        name: "React JS",
        classes: FRONTEND_CSS,
      },
      {
        name: "TailwindCSS",
        classes: FRONTEND_CSS,
      },
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
      {
        name: "Jenkins",
        classes: OTHERS_CSS,
      },
    ],
    from: "July 21, 2020",
    to: "Jan 10, 2021",
    link: "",
  },
  {
    title: "Menged",
    desc: "MENGED helps you easily search, compare and book intercity bus tickets around the world. Search and book tickets from thousands of bus companies instantly.",
    image: "https://menged.com/img/bus_avatar.jpeg",
    languages: [
      {
        name: "React JS",
        classes: FRONTEND_CSS,
      },
      {
        name: "TailwindCSS",
        classes: FRONTEND_CSS,
      },
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
      {
        name: "Jenkins",
        classes: OTHERS_CSS,
      },
    ],
    from: "November 13, 2020",
    to: "June 13, 2021",
    link: "https://menged.com/",
  },

  {
    title: "YeneWekil",
    desc: "Commercial and residential property management system.",
    image: "/images/yenewekil.png",
    languages: [
      {
        name: "React JS",
        classes: FRONTEND_CSS,
      },
      {
        name: "TailwindCSS",
        classes: FRONTEND_CSS,
      },
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
      {
        name: "Jenkins",
        classes: OTHERS_CSS,
      },
    ],
    from: "Mar 4, 2020",
    to: "Dec 4, 2021",
    link: "https://admin.yenewekil.com/",
  },

  {
    title: "Delivery as a service",
    desc: "Backend system for a delivery as a service platform",
    image:
      "https://png.pngtree.com/png-vector/20201123/ourmid/pngtree-programming-website-flat-line-concept-png-image_2470751.jpg",
    languages: [
      {
        name: ".Net Core",
        classes: BACKEND_CSS,
      },
      {
        name: "React JS",
        classes: FRONTEND_CSS,
      },
      {
        name: "Firebase",
        classes: INFRASTRUCTURE_CSS,
      },
      {
        name: "Google Cloud",
        classes: INFRASTRUCTURE_CSS,
      },
      {
        name: "Jenkins",
        classes: OTHERS_CSS,
      },
    ],
    from: "Dec 1, 2020",
    to: "Mar 30, 2021",
    link: "",
  },
  {
    title: "YERRAS",
    desc: "A Livestock supply chain management system.",
    image:
      "https://lh5.googleusercontent.com/p/AF1QipOlzvCDBAVXYEGWquC5Q_UG131q1tIG7IFxsAg",
    languages: [
      {
        name: "React JS",
        classes: FRONTEND_CSS,
      },
      {
        name: "TailwindCSS",
        classes: FRONTEND_CSS,
      },
      {
        name: ".NET Core",
        classes: BACKEND_CSS,
      },
      {
        name: "Git",
        classes: OTHERS_CSS,
      },
      {
        name: "Jenkins",
        classes: OTHERS_CSS,
      },
    ],
    from: "July 31, 2020",
    to: "Dec 1, 2020",
    link: "http://yerrasgebeya.com/",
  },
  {
    title: "Mekina Tera",
    desc: "Mobile Application for managing cars to sell",
    image:
      "https://play-lh.googleusercontent.com/Wa2SIBGofNtW7G3Aq77Xcdj8-gdFbyqTZjb7NDDDznu8D7i9Z56J5j9XMvEo73HQxBg=s180-rw",
    languages: [
      {
        name: "React Native",
        classes: MOBILE_CSS,
      },
      {
        name: "PHP Codeignitor",
        classes: BACKEND_CSS,
      },
    ],
    from: "Jan 31, 2019",
    to: "Feb 31, 2019",
    link: "https://play.google.com/store/apps/details?id=com.mekinatera",
  },
  {
    title: "Quranify",
    desc: "Listening to Quran recitations by more than 100+ famous reciters in the world, Islamic radios and Islamic TVs. ",
    image:
      "https://play-lh.googleusercontent.com/ZCEPG5SjcGjEHHsQ9VanifSjabIFGFlIeqSPZT4pIIgeKHNWihy4t7VFVsdIX19Kxnw=s180-rw",
    languages: [
      {
        name: "React Native",
        classes: MOBILE_CSS,
      },
      {
        name: "PHP Codeignitor",
        classes: BACKEND_CSS,
      },
    ],
    from: "Dec 1, 2018",
    to: "Jan 15, 2019",
    link: "https://play.google.com/store/apps/details?id=com.quranify",
  },
  {
    title: "Muraqabat",
    desc: "Online visa ordering and processing platform",
    image: "https://muraqabat.com/img/main_logo.jpg",
    languages: [
      {
        name: "Laravel",
        classes: BACKEND_CSS,
      },
      {
        name: "Bootstrap",
        classes: FRONTEND_CSS,
      },
    ],
    from: "Dec 1, 2018",
    to: "Feb 20, 2019",
    link: "https://muraqabat.com",
  },
  {
    title: "Empire Technology",
    desc: "Landing page for a tech company",
    image: "https://www.empiretechnology.net/img/main.png",

    languages: [
      {
        name: "HTML",
        classes: FRONTEND_CSS,
      },
      {
        name: "Bootstrap",
        classes: FRONTEND_CSS,
      },
    ],
    from: "Jan 31, 2019",
    to: "Feb 5, 2019",
    link: "https://www.empiretechnology.net/",
  },

  {
    title: "Streaming Backend Web Service for Sheger FM 102.1",
    desc: "API for frontend apps for Sheger FM 102.1 ",
    image:
      "https://dbs.radioline.fr/pictures/radio_2b69cc0058f2369404757e2aad091f81/logo200.jpg?size=600",
    languages: [
      {
        name: "PHP",
        classes: BACKEND_CSS,
      },
    ],

    from: "Jan 20, 2016",
    to: "Feb 31, 2016",
    link: "",
  },
  {
    title: "Enhid",
    desc: "Landing page for a tech company",
    image: "https://enhid.net/images/enhid_logo.png",

    languages: [
      {
        name: "HTML",
        classes: FRONTEND_CSS,
      },
      {
        name: "Bootstrap",
        classes: FRONTEND_CSS,
      },
    ],
    from: "Feb 31, 2015",
    to: "Mar 5, 2015",
    link: "https://enhid.net",
  },
];
